import { render, staticRenderFns } from "./Areas-Cargos.vue?vue&type=template&id=741a2907"
import script from "./Areas-Cargos.vue?vue&type=script&lang=js"
export * from "./Areas-Cargos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports